import { render, staticRenderFns } from "./PasteFormat.vue?vue&type=template&id=12436356&"
import script from "./PasteFormat.vue?vue&type=script&lang=js&"
export * from "./PasteFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports